export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-3.2fc1a3c1.png";